<div class="card-material" [ngClass]="{'d-none': !imageLoaded}">

    <img (load)="loadImage()" class="background-sp" [src]="urlCapa">

    <div class="card-overlay">
        <div class="card-top">
            <status-badge *ngIf="disponivel" [tipo]="'disponivel'" label="Disponível"></status-badge>
            <status-badge *ngIf="!disponivel" [tipo]="'bloqueado'" label="Bloqueado"
                [tooltip]="tooltipCadeado()"></status-badge>

            <div class="card-title" [ngClass]="{'card-title--bloqueado': !disponivel}">{{ material.nome }}</div>
        </div>

        <div class="card-actions">
            <div class="card-actions__row">
                <button mat-mini-fab color="primary" (click)="iniciar()" [disabled]="!disponivel">
                    <mat-icon>{{ iconAcao }}</mat-icon>
                </button>
                <span class="ms-3">{{ labelAcao }}</span>
            </div>
            <div class="card-info">
                <span class="card-info__tipo">{{ labelTipoMaterial }}</span>
                <span class="card-info__expira" *ngIf="licenca.disponivel_ate">
                    Válido até {{ converterData(licenca.disponivel_ate) }}
                </span>
            </div>
        </div>
    </div>

    <img *ngIf="!disponivel" class="cadeado" src="assets/img/cadeado.svg" [matTooltip]="tooltipCadeado()"
        [matTooltipShowDelay]="600">
</div>


<div class="skeleton-card" *ngIf="!imageLoaded">
    <div class="skeleton-image" [ngStyle]="{
            'aspect-ratio': constantsWidthHeightMidia.lg.width / constantsWidthHeightMidia.lg.height
        }"></div>
    <div class="skeleton-text">
        <div class="skeleton-line short"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
    </div>
</div>
